import store from "../../../../../../../store";
import {
  rotatePoint,
  getPointDistance,
  getPointField,
  findClosestPointPairs, inchesToMm,
} from "../../../../../helpers/sqftHelper";
// import ShapeHelper from "../../../../../helpers/shapeHelper";
import RenderFigures from "../../../helpers/renderFigures";
import {getClosestIntersectionPoints, getIntersectionPointsAndLines} from "../shapeParts/slabParts/seamToolHelper";
import {COLORS} from "../../../../../../../colorThemes";
import sqftConfig from "../../../store/sqftConfig";
import {MEASURE_UNITS} from "../../../../../constants";

class RenderMeasurementsInsideShape {
  constructor(movableImage) {
    this.movableImage = movableImage;
    this.outerShape = null;
    this.lineOffset = 1;

    const serverState = store.getState().serverState;
    this.lineStartVertical = { x: -serverState.windowWidth, y: 0 };
    this.lineEndVertical = { x: serverState.windowWidth, y: 0 };
    this.lineStartHorizontal = { x: 0, y: -serverState.windowHeight };
    this.lineEndHorizontal = { x: 0, y: serverState.windowHeight };
  }

  setOuterShape = (value) => {
    this.outerShape = value
  }

  updateLinePoints() {
    const serverState = store.getState().serverState;
    const imageCenter = this.movableImage.getCenter();
    const angle = this.movableImage.rotatedDegrees;
    const imagePosOnField = this.movableImage.getCenterPosition();
    const pos = this.outerShape.getPosition();
    const imagePosOnShape = {x: imagePosOnField.x - pos.x, y: imagePosOnField.y - pos.y};
    void imagePosOnShape;
    void imageCenter;

    this.lineStartVertical = rotatePoint({ x: -serverState.windowWidth, y: imagePosOnShape.y }, imagePosOnShape, -angle);
    this.lineEndVertical = rotatePoint( { x: serverState.windowWidth, y: imagePosOnShape.y }, imagePosOnShape, -angle);
    this.lineStartVerticalOnImage = rotatePoint( { x: -serverState.windowWidth, y: imageCenter.y }, imageCenter, -angle);
    this.lineEndVerticalOnImage = rotatePoint({ x: serverState.windowWidth, y: imageCenter.y }, imageCenter, -angle);

    this.lineStartHorizontal = rotatePoint( { x: imagePosOnShape.x, y: -serverState.windowHeight }, imagePosOnShape, -angle);
    this.lineEndHorizontal = rotatePoint({ x: imagePosOnShape.x, y: serverState.windowHeight }, imagePosOnShape, -angle);
    this.lineStartHorizontalOnImage = rotatePoint( { x: imageCenter.x, y: -serverState.windowHeight }, imageCenter, -angle);
    this.lineEndHorizontalOnImage = rotatePoint({ x:  imageCenter.x, y: serverState.windowHeight }, imageCenter, -angle);
  }

  render = (ctx) => {
    this.updateLinePoints();
    const imageCenterPosOnField = this.movableImage.getCenterPosition();
    const pos = this.outerShape.getPosition();
    const imageCenterPosOnShape = {x: imageCenterPosOnField.x - pos.x, y: imageCenterPosOnField.y - pos.y};
    const imagePosOnField = this.movableImage.getPosition();
    const imagePosOnShape = {x: imagePosOnField.x - pos.x, y: imagePosOnField.y - pos.y};

    ctx.lineWidth = 1;
    ctx.strokeStyle = COLORS.red; //COLOR_THEMES[sqftConfig.activeTheme].primary;

    // horizontal line
    const sideImagePoints = this.getImageSidePoints(this.lineStartVerticalOnImage, this.lineEndVerticalOnImage);
    const sideShapePoints = this.getShapeSidePoints(this.lineStartVertical, this.lineEndVertical);
    this.renderLineToBorder(ctx, sideShapePoints, sideImagePoints, imagePosOnShape);

    // vertical line
    this.renderArrowLineToCenter(ctx, imageCenterPosOnShape);
  }

  getImageSidePoints = (verticalLinePoint1, verticalLinePoint2) => {
    const lines = this.movableImage.getLines();

    return getIntersectionPointsAndLines(
      lines, verticalLinePoint1, verticalLinePoint2
    );
  }

  getShapeSidePoints = (verticalLinePoint1, verticalLinePoint2) => {
    return getIntersectionPointsAndLines(
      this.outerShape.getLines(true), verticalLinePoint1, verticalLinePoint2
    );
  }

  renderLineToBorder = (ctx, sideShapePoints, sideImagePoints, imagePosOnShape) => {
    if (!sideShapePoints.length) {
      return
    }
    const shapePos = this.outerShape.getPosition();
    const intersectionsWithShape = sideShapePoints.map(sideShapePoint => {
      return sideShapePoint.intersectionCords;
    });

    const intersectionsWithImage = sideImagePoints.map(sideImagePoint => {
      return {
        x: sideImagePoint.intersectionCords.x + imagePosOnShape.x,
        y: sideImagePoint.intersectionCords.y + imagePosOnShape.y,
        imageLine: sideImagePoint.line
      };
    });

    const closestPointPairs = findClosestPointPairs(intersectionsWithShape, intersectionsWithImage);

    for (const [index, closestPointPair] of closestPointPairs.entries()) {
      if (closestPointPair.pointA && closestPointPair.pointB) {
        const startPointField = getPointField(closestPointPair.pointA.x, closestPointPair.pointA.y, this.outerShape);
        const endPointField = getPointField(closestPointPair.pointB.x, closestPointPair.pointB.y, this.outerShape);

        ctx.beginPath();
        ctx.moveTo(startPointField.x, startPointField.y);
        ctx.lineTo(endPointField.x, endPointField.y);

        ctx.closePath();
        ctx.stroke();

        //const fontSize = getFontSizeFromContext(ctx);
        //let midPoint = getMidPoint(closestPointPair.pointA, closestPointPair.pointB);
        //midPoint = {x: midPoint.x + shapePos.x, y: midPoint.y + shapePos.y - fontSize / 2 / scale}
        const length = sqftConfig.measureUnit === MEASURE_UNITS.Metric
          ? inchesToMm(closestPointPair.distance, false, true)
          : closestPointPair.distance;

        // this.renderLineMeasurement(ctx,
        //   midPoint,
        //   length < 0.3 ? '' : length,
        // )
        const betweenPointFrom = {
          x: closestPointPair.pointA.x + shapePos.x,
          y: closestPointPair.pointA.y + shapePos.y
        }
        const betweenPointTo = {
          x: closestPointPair.pointB.x + shapePos.x,
          y: closestPointPair.pointB.y + shapePos.y
        }

        //closestPointPair.pointB.imageLine.measurementInsideShape.setPos(midPoint);
        closestPointPair.pointB.imageLine.measurementInsideShape.setPos({x: 1, y: 1}); // this is needed to render measurements
        closestPointPair.pointB.imageLine.measurementInsideShape.setValue(length);

        void index;
        if (closestPointPair.pointB.imageLine.lineIndex === 1) {
           closestPointPair.pointB.imageLine.measurementInsideShape.setBetweenPoints(betweenPointTo, betweenPointFrom); // this will override pos value
        } else {
          closestPointPair.pointB.imageLine.measurementInsideShape.setBetweenPoints(betweenPointFrom, betweenPointTo); // this will override pos value
        }
      }
    }
  }

  renderArrowLineToCenter = (ctx, imageCenterPosOnShape) => {
    let imageCenterPosOnShapePointField = getPointField(imageCenterPosOnShape.x, imageCenterPosOnShape.y, this.outerShape);
    let [intersectionXPointAndLine1, intersectionXPointAndLine2] = getClosestIntersectionPoints(
      this.outerShape.getLines(true), this.lineStartHorizontal, this.lineEndHorizontal, imageCenterPosOnShape
    );

    // we need only image lines that was intersected with the center line that supposed to be lines with the index 0 and 2
    let [intersectionXPointAndLine1WithImage, intersectionXPointAndLine2WithImage] = getClosestIntersectionPoints(
      this.movableImage.getLines(true), this.lineStartHorizontalOnImage, this.lineEndHorizontalOnImage, this.movableImage.getCenterPosition()
    );

    if (intersectionXPointAndLine1 && intersectionXPointAndLine2) {
      let intersectionXPoint1 = intersectionXPointAndLine1.intersectionCords;
      let intersectionXPoint2 = intersectionXPointAndLine2.intersectionCords;
      let intersectionXPoint1PointField = getPointField(intersectionXPoint1.x, intersectionXPoint1.y, this.outerShape);
      let intersectionXPoint2PointField = getPointField(intersectionXPoint2.x, intersectionXPoint2.y, this.outerShape);

      ctx.beginPath();
      RenderFigures.drawArrow(ctx,
        intersectionXPoint1PointField.x,
        intersectionXPoint1PointField.y + this.lineOffset,
        imageCenterPosOnShapePointField.x,
        imageCenterPosOnShapePointField.y - this.lineOffset
      );

      RenderFigures.drawArrow(ctx,
        imageCenterPosOnShapePointField.x,
        imageCenterPosOnShapePointField.y + this.lineOffset,
        intersectionXPoint2PointField.x,
        intersectionXPoint2PointField.y - this.lineOffset
      );
      ctx.closePath();
      ctx.stroke();

      //const scale = sqftConfig.scale;
      let measurement1Distance = getPointDistance(intersectionXPoint1, imageCenterPosOnShape);
      measurement1Distance = sqftConfig.measureUnit === MEASURE_UNITS.Metric
        ? inchesToMm(measurement1Distance, false, true)
        : measurement1Distance;

      const shapePos = this.outerShape.getPosition();
      const betweenPointTo = {
        x: intersectionXPoint1.x + shapePos.x,
        y: intersectionXPoint1.y + shapePos.y
      }
      const betweenPointFrom = {
        x: imageCenterPosOnShape.x + shapePos.x,
        y: imageCenterPosOnShape.y + shapePos.y
      }
      if (intersectionXPointAndLine1WithImage) {
        intersectionXPointAndLine1WithImage.line.measurementInsideShape.setPos({x: 1, y: 1});
        intersectionXPointAndLine1WithImage.line.measurementInsideShape.setValue(measurement1Distance);
        intersectionXPointAndLine1WithImage.line.measurementInsideShape.setBetweenPoints(betweenPointFrom, betweenPointTo);
      }

      // THIS CALCULATIONS WAS USED TO GET POS WITHOUT USING BETWEEN POINTS
      //const measurement1Midpoint = getMidPoint(intersectionXPoint1, imageCenterPosOnShape);
      //const metrics1Point = ctx.measureText(measurement1Distance);
      //const shapePos = this.outerShape.getPosition();
      // const offsetPoint1 = {
      //   x: measurement1Midpoint.x + shapePos.x + metrics1Point.width / 2 / scale,
      //   y: measurement1Midpoint.y + shapePos.y
      // }
      //const measurement1angle = getAngleBetweenTwoPoints(intersectionXPoint2, imageCenterPosOnShape);
      //intersectionXPointAndLine1WithImage.line.measurementInsideShape.setAngle(measurement1angle);
      //intersectionXPointAndLine1WithImage.line.measurementInsideShape.setPos(offsetPoint2);
      //intersectionXPointAndLine1WithImage.line.measurementInsideShape.setBetweenPoints(null, null);

      // THIS CALCULATIONS WAS USED TO GET POS WITHOUT USING BETWEEN POINTS
      // const measurement2Midpoint = getMidPoint(intersectionXPoint2, imageCenterPosOnShape);
      // const metrics2Point = ctx.measureText(measurement2Distance);
      // const offsetPoint2 = {
      //   x: measurement2Midpoint.x + shapePos.x + metrics2Point.width / 2 / scale,
      //   y: measurement2Midpoint.y + shapePos.y
      // }
      // const measurement2angle = getAngleBetweenTwoPoints(intersectionXPoint2, imageCenterPosOnShape);
      // intersectionXPointAndLine2WithImage.line.measurementInsideShape.setPos(offsetPoint2);
      // intersectionXPointAndLine2WithImage.line.measurementInsideShape.setAngle(measurement2angle);

      let measurement2Distance = getPointDistance(intersectionXPoint2, imageCenterPosOnShape);
      measurement2Distance = sqftConfig.measureUnit === MEASURE_UNITS.Metric
        ? inchesToMm(measurement2Distance, false, true)
        : measurement2Distance;

      const measurement2BetweenPointTo = {
        x: intersectionXPoint2.x + shapePos.x,
        y: intersectionXPoint2.y + shapePos.y
      }
      const measurement2BetweenPointFrom = {
        x: imageCenterPosOnShape.x + shapePos.x,
        y: imageCenterPosOnShape.y + shapePos.y
      }
      if (intersectionXPointAndLine1WithImage) {
        intersectionXPointAndLine2WithImage.line.measurementInsideShape.setPos({x: 1, y: 1});
        intersectionXPointAndLine2WithImage.line.measurementInsideShape.setValue(measurement2Distance);
        intersectionXPointAndLine2WithImage.line.measurementInsideShape.setBetweenPoints(measurement2BetweenPointFrom, measurement2BetweenPointTo);
      }
    }
  }

  // renderLineMeasurement = (ctx, measurementPos, measurementDistance) => {
  //   this.__measurement.pos.x = measurementPos.x;
  //   this.__measurement.pos.y = measurementPos.y;
  //   this.__measurement.value = measurementDistance;
  //
  //   this.__measurement.render(ctx);
  // }
}

export default RenderMeasurementsInsideShape
